import { render, staticRenderFns } from "./purchase-price.vue?vue&type=template&id=234ba1b0&scoped=true&"
import script from "./purchase-price.vue?vue&type=script&lang=js&"
export * from "./purchase-price.vue?vue&type=script&lang=js&"
import style0 from "./purchase-price.vue?vue&type=style&index=0&id=234ba1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ba1b0",
  null
  
)

export default component.exports